import PurchaseOrders from "../../../../src/pages/use-cases/page-content/financial/purchase-orders.md";
import * as React from 'react';
export default {
  PurchaseOrders,
  React
};